<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-shield-alt"></i> LISTA
            BLANCA
          </p>
        </div>

        <div
          class="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"
          align="center"
          style="display: flex"
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh">
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 3" :key="i">
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- <div class="row mb-3" v-if="!loading">
        <div class="col-12 col-md-6">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Ingrese email o número de teléfono"
              v-model="newEntry"
            />
            <button class="btn btn-primary" @click="addToWhitelist">
              Agregar a Lista Blanca
            </button>
          </div>
        </div>
      </div> -->

      <DataTable
        v-if="!loading"
        :columns="columns"
        :options="options"
        :data="whitelistEntries"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Agregado el</th>
            <th data-priority="1">Nombre</th>
            <th>DNI</th>
            <th data-priority="2">Rol</th>
            <th data-priority="3">Distribuidor</th>
            <th>Agregado por</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";

DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    Skeletor,
  },
  name: "Whitelist",
  data() {
    return {
      whitelistEntries: [],
      loading: false,
      newEntry: "",
      columns: [
        {
          data: null,
          render: function (data) {
            const createdAt = new Date(
              data.createdAt._seconds * 1000 +
                data.createdAt._nanoseconds / 1000000,
            );
            return createdAt.toLocaleString("es-ES", {
              timeZone: "America/Guayaquil",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            });
          },
        },

        {
          data: null,
          render: function (data) {
            return data.names + " " + data.lastnames;
          },
        },
        {
          data: "dni",
        },
        {
          data: null,
          render: function (data) {
            return data.role === "manager"
              ? "Administrador"
              : data.role === "salesRep"
                ? "Vendedor"
                : "PlanPro";
          },
        },
        {
          data: null,
          render: function (data) {
            return data.companyName || "Administrador";
          },
        },
        {
          data: null,
          render: function (data) {
            return data.addedBy || "Administrador";
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords:
            "Lo sentimos, no se encontraron registros en la lista blanca",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  mounted() {
    this.getWhitelist();
    this.setupEventListeners();
  },
  methods: {
    async getWhitelist() {
      try {
        this.loading = true;
        const res = await this.$https.post("/administration/fetchWhitelist", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
        });
        this.whitelistEntries = res.data.whitelist || [];
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async addToWhitelist() {
      if (!this.newEntry) {
        this.$toast.error("Ingrese un email o teléfono válido", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      try {
        this.loading = true;
        // Determine if input is email or phone
        const isEmail = this.newEntry.includes("@");
        const type = isEmail ? "email" : "phone";

        const res = await this.$https.post("/administration/addToWhitelist", {
          tokenAuth: this.$store.state.tokenAuth,
          userId: this.$store.state.user.userId,
          value: this.newEntry,
          type: type,
        });

        this.$toast.success("Agregado a la lista blanca exitosamente", {
          position: "top-right",
          max: 10,
        });

        this.newEntry = "";
        this.getWhitelist();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async removeFromWhitelist(id) {
      try {
        this.loading = true;
        const res = await this.$https.post(
          "/administration/removeFromWhitelist",
          {
            tokenAuth: this.$store.state.tokenAuth,
            userId: this.$store.state.user.userId,
            entryId: id,
          },
        );

        this.$toast.success("Eliminado de la lista blanca exitosamente", {
          position: "top-right",
          max: 10,
        });

        this.getWhitelist();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    handleError(error) {
      if (error.response && error.response.status === 401) {
        this.$store.dispatch("clearAllData");
        this.$toast.error(error.response.data.message, {
          position: "top-right",
          max: 10,
        });
        this.$router.push({ name: "Signin" });
      } else if (error.response && error.response.status === 403) {
        this.$router.push({ name: "Dashboard" });
        this.$toast.error("Acceso no autorizado", {
          position: "top-right",
          max: 10,
        });
      } else {
        this.$toast.error(
          error.response ? error.response.data.message : "Error desconocido",
          {
            position: "top-right",
            max: 10,
          },
        );
      }
    },

    refresh() {
      this.cleanupEventListeners();
      this.getWhitelist();
      this.setupEventListeners();
    },

    setupEventListeners() {
      $(document).off("click", ".remove-btn");
      $(document).on("click", ".remove-btn", (event) => {
        const id = $(event.currentTarget).data("id");
        this.removeFromWhitelist(id);
      });
    },

    cleanupEventListeners() {
      $(document).off("click", ".remove-btn");
    },
  },
  beforeUnmount() {
    this.cleanupEventListeners();
  },
};
</script>

<style scoped></style>
